export default "__VITE_ASSET__CSckQ$bG__"